import { Box, styled } from '@mui/material';
import Page from 'components/new/Page';
import Stepper from 'components/new/Stepper';
import { LP_REALISATION_LIST } from 'adminConstants/routes';
import { Steps, stepLabels } from './steps';
import React, { PropsWithChildren } from 'react';

const StepperWrapper = styled(Box)({
  width: 600,
  maxWidth: 600,
  minWidth: 0,
});

type Props = {
  activeStep?: Steps;
  actionBar?: React.ReactNode;
};

const RealisationsPage: React.FC<PropsWithChildren<Props>> = ({
  activeStep,
  actionBar,
  children,
}) => (
  <Page
    spacing="lg"
    withStickyHeader
    tabTitle="Realisations: Add realisation"
    withHeadingDivider
    headerBreakpoint="md"
    heading="Add realisation"
    goBackAction={LP_REALISATION_LIST}
    customActions={
      <StepperWrapper>
        <Stepper
          activeOnlyBreakpoint="sm"
          steps={Object.values(stepLabels)}
          activeStep={activeStep}
        />
      </StepperWrapper>
    }
    actionBar={actionBar}
  >
    {children}
  </Page>
);

export default RealisationsPage;
